"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var encode_1 = __importDefault(require("./encode"));
exports.default = (function (virtual) {
    var en = encode_1.default(virtual)[virtual.device.workModeType];
    return function (data) {
        return en ? en(data) : data;
    };
});



// WEBPACK FOOTER //
// ./src/encode/index.ts